export const USD = "USD";
export const INR = "INR";
